module.exports = __webpack_public_path__ + "static/media/ero_power-gainon_logo.7c10d38e.png";